import { Disclosure, Transition } from "@headlessui/react";
import { ChevronDownIcon, ChevronRightIcon } from "@heroicons/react/20/solid";
import routes from "../../shared/routes";

import { Link, useLocation } from "react-router-dom";

import { useState } from "react";
import { tenantLogoUrl } from "../../shared/tenantBranding";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function SideNavigationBar(props) {
  const { outsideClickRef, user_type, user_id, tenant, finance } = props;

  const [isMinimized, setIsMinimized] = useState(false);

  const location = useLocation();
  const getRoutes = routes(
    location.pathname,
    parseInt(user_type),
    tenant,
    parseInt(user_id),
    finance,
  );
  const routesArray = getRoutes["routes"];
  const logoSrc = tenantLogoUrl(tenant);
  const companyName = tenant?.name ?? "WIP Sync";

  return (
    <div className="layout-sidebar hide-for-print bg-card" ref={outsideClickRef}>
      <div className="flex grow flex-col gap-y-4 overflow-y-auto px-6 pr-0 sm:pr-6 pb-4">
        <div className="mt-5 mb-1 shrink-0 border-b border-border-subtle pb-5">
          <div className="flex justify-center">
            {logoSrc ? (
              <img
                className="max-h-20 w-auto max-w-[180px] object-contain"
                src={logoSrc}
                alt={`${companyName} logo`}
              />
            ) : (
              <div className="flex h-14 w-14 items-center justify-center rounded-full bg-accent-soft text-lg font-bold text-brand">
                {companyName.charAt(0).toUpperCase()}
              </div>
            )}
          </div>
          <div className="mt-3 text-center">
            <p className="truncate text-[15px] font-semibold leading-5 text-brand">
              {companyName}
            </p>
          </div>
        </div>
        <nav className="layout-menu-container flex flex-1 flex-col">
          <ul className="flex flex-1 flex-col gap-y-7">
            <li>
              <ul className="space-y-1">
                {routesArray.map((item) => (
                  <li key={item.name}>
                    {!item.children ? (
                      <Link
                        to={item.href}
                        className={classNames(
                          item.current
                            ? "bg-accent-soft font-semibold text-accent-dark"
                            : "text-color hover:bg-accent-soft/60",
                          "group flex gap-x-3 rounded-xl p-2 text-sm leading-6",
                        )}
                      >
                        <item.icon
                          className={classNames(
                            item.current ? "text-accent-dark" : "text-brand",
                            "h-5 w-5 shrink-0",
                          )}
                          aria-hidden="true"
                        />
                        <p className={isMinimized ? "hidden" : null}>
                          {item.name}
                        </p>
                      </Link>
                    ) : (
                      <Disclosure
                        as="div"
                        defaultOpen={item.open}
                        className="sidebar-parent-div"
                      >
                        {({ open }) => (
                          <>
                            <Disclosure.Button
                              className={classNames(
                                item.current
                                  ? "bg-accent-soft font-semibold text-accent-dark"
                                  : "text-color hover:bg-accent-soft/60",
                                "flex w-full items-center gap-x-3 rounded-xl p-2 text-left text-sm leading-6",
                              )}
                              onClick={() => setIsMinimized(false)}
                            >
                              <item.icon
                                className={classNames(
                                  item.current
                                    ? "text-accent-dark"
                                    : "text-brand",
                                  "h-5 w-5 shrink-0",
                                )}
                                aria-hidden="true"
                              />
                              <div className="flex w-full">
                                {item.name}
                                {open ? (
                                  <ChevronDownIcon
                                    className="text-color ml-auto h-5 w-5 shrink-0"
                                    aria-hidden="true"
                                  />
                                ) : (
                                  <ChevronRightIcon
                                    className="text-color ml-auto h-5 w-5 shrink-0"
                                    aria-hidden="true"
                                  />
                                )}
                              </div>
                            </Disclosure.Button>
                            <Transition
                              enter="duration-500 ease-out"
                              enterFrom="opacity-0 -translate-y-6"
                              enterTo="opacity-100 translate-y-0"
                              leave="duration-500 ease-out"
                              leaveFrom="opacity-100 translate-y-0"
                              leaveTo="opacity-0 -translate-y-6"
                            >
                              <Disclosure.Panel as="ul" className="mt-1 px-2">
                                {item.children.map((subItem) => (
                                  <li key={subItem.name}>
                                    <Disclosure.Button
                                      as={Link}
                                      to={subItem.href}
                                      className={classNames(
                                        subItem.current
                                          ? "font-semibold text-accent-dark"
                                          : "text-color hover:bg-accent-soft/60",
                                        "block rounded-xl py-2 pr-2 pl-9 text-sm leading-6",
                                      )}
                                    >
                                      {subItem.name}
                                    </Disclosure.Button>
                                  </li>
                                ))}
                              </Disclosure.Panel>
                            </Transition>
                          </>
                        )}
                      </Disclosure>
                    )}
                  </li>
                ))}
              </ul>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
}
